import { http } from "../../services/app/app.service";

const UserService = {
  // /**
  //  * User Sign in api call old api//m1972463
  //  * @param {object} signInData - the signin payload
  //  */
  // signIn: (signInData) => {
  //   return http
  //     .post("/veuitNetwork/m2001568", signInData)
  //     .then((res) => res.data)
  //     .catch((error) => ({ error }));
  // },
  /**
   * Get contact us Subjects
   * @param {object} payload - the post data payload
   */
  getContactSubjects: (payload) => {
    return http
      .post("/commonrestapi/m1391103", payload)
      .then((res) => res.data)
      .catch((error) => ({ error }));
  },

  /**
   * save contact us
   * @param {object} payload - the post data payload
   */
  saveContactUs: (payload) => {
    return http
      .post("/commonrestapi/m1357069", payload)
      .then((res) => res.data)
      .catch((error) => ({ error }));
  },

  getOfficeAddress: (payload) => {
    return http
      .post("/commonadmin/m2208183", payload)
      .then((res) => res.data)
      .catch((error) => ({ error }));
  },
};

export default UserService;
